export const getFileName = path => path.split('/').pop().split('.')[0];
